import React, { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import Dashboard from "../Components/Dashboard";
import StockFilter from "../Components/StockFilter";
import { SCREENER_FILTERS } from "../Service/screener_filters";
import { getDashboards } from "../Service/dashboards";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useTheme } from "@mui/material/styles";
import {
  Card,
  CardHeader,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";

import TreemapCharts from "../Components/TreemapCharts";

const Home = (props) => {
  const [data, setData] = useState();
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);
  // const [dashboard, setDashboard] = React.useState();

  const theme = useTheme();

  useEffect(() => {
    try {
      getDashboards().then((data) => {
        setData(data);
        // setDashboard(data[0]);
        setLoading(false);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, []);

  useEffect(() => {
    if (data !== undefined && data !== null) {
      setLoading(false);
      setNoData(false);
    }
  }, [data]);

  return (
    <div
      style={{
        paddingLeft: "20px",
        display: "flex",
        flexDirection: "column",
        minWidth: '100vw',
        background: `${theme.palette.background.default}`,
      }}
    >
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          Calenders & Earnings
        </AccordionSummary>
        <AccordionDetails>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <a style={{marginRight: "50px" }} href="https://tradingeconomics.com/calendar" target="_blank">https://tradingeconomics.com/calendar</a>
              <a href="https://tradingeconomics.com/earnings" target="_blank">https://tradingeconomics.com/earnings</a>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
       {/* <TreemapCharts></TreemapCharts> */}
      <Dashboard />
    </div>
  );
};

export default Home;
